


























import {
  defineComponent, computed, ref, watch,
} from '@vue/composition-api';

import getAttachment from '@/gql/getAttachment.gql';

import CommonDropzoneWithFileUpload from '@/components/CommonDropzoneWithFileUpload.vue';
import { useQuery, useResult } from '@vue/apollo-composable';

const PanelWithFileInput = defineComponent({
  components: {
    CommonDropzoneWithFileUpload,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    type: {
      type: String,
      validation: (input: string) => ['IMAGE', 'ARCHIVE'].indexOf(input) !== -1,
    },
  },
  setup(props, context) {
    const isShowUpload = ref(false);

    const { result: getAttachmentResult, refetch } = useQuery(getAttachment, computed(() => ({
      id: (props.value.length > 0) ? props.value[0] : undefined,
    })));
    const attachment = useResult(getAttachmentResult, null, (data: any) => data.attachment);

    watch(() => props.value, () => { refetch(); });

    function onUploadDone(data: any) {
      context.emit('input', [data.id]);
    }

    return {
      isShowUpload,
      attachment,
      onUploadDone,
    };
  },
});

export default PanelWithFileInput;
